export default __webpack_public_path__ + "static/media/bannerZmeny.36a0717a.webp";